import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

export const echo = new Echo({
  broadcaster: 'pusher',
  key: import.meta.env.VITE_PUSHER_APP_KEY || 'aba88fde6879b2713192',
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'us2',
  forceTLS: true,
});